<div class="max-width-p">
    <div class="mt-2 mb-4">
        <benefit-header-summary [headerText]="shop.name" [showBudgetCard]="false"></benefit-header-summary>
    </div>
    <div class="card" *ngIf="!selectedCoupon; else useDiscountCode">
        <div class="card-body">
            <div class="row">
                <div class="col-3">
                    <img [src]="shop?.logo" class="img" *ngIf="shop"/>
                </div>
                <div class="col-9 text-align-left coupon-title">
                    {{ 'CASHBACK.DETAILS_PAGE.SHOP_DESCRIPTION' | translate: {name: shop.name} }}
                </div>
            </div>
        </div>
    </div>

    <ng-template #useDiscountCode>
        <div class="content">
            <div class="row">
                <div class="col-md-8 col-xs-12">
                    <div class="card h-130">
                        <div class="card-body pb-0">
                            <div class="row">
                                <div class="card-title" [ngClass]="(selectedCoupon.discountPercent === 0 )? 'col-md-4' : 'col-md-3'">
                                    <span *ngIf="selectedCoupon.discountPercent === 0; else hasDiscountValue"
                                          class="display-4 brick-red darken-2">
                                {{ 'CASHBACK.DETAILS_PAGE.GENERAL_OFFER' | translate }}
                                    </span>
                                    <ng-template #hasDiscountValue>
                                        <span class="display-3 brick-red darken-2">{{ selectedCoupon.discountPercent }}</span>&nbsp;<span
                                            class="display-5 brick-red darken-2 text-left" *ngIf="selectedCoupon.discountType === 'percent'">%</span>
                                        <span
                                                class="display-5 brick-red darken-2 text-left" *ngIf="selectedCoupon.discountType === 'fixed'">RON</span>
                                    </ng-template>
                                </div>
                                <div class="right text-left coupon-title col-md-8">
                                    <div class="card-title">
                                        <p>{{ selectedCoupon.title }}</p>
                                        <p>{{ selectedCoupon.description }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 col-xs-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="text-center">
                                <div class="input-group input-group-merge mb-1">
                                    <input
                                            type="text"
                                            class="form-control"
                                            id="readonlyInput"
                                            readonly="readonly"
                                            value='{{ getCode(selectedCoupon) }}'
                                            aria-label="Code"
                                    />
                                    <div class="input-group-append">
                                        <button class="btn btn-outline-primary" readonly="readonly"
                                                (click)="copyCode(selectedCoupon)" title="Copy to clipboard">
                                            <span [data-feather]="'clipboard'"></span>
                                        </button>
                                    </div>
                                </div>
                                <div class="input-group mb-0">
                                    <button class="btn btn-primary input-group text-center"
                                            (click)="visitCouponSite(selectedCoupon)">
                                        <span class="mr-1" [data-feather]="'external-link'"></span>{{ 'CASHBACK.DETAILS_PAGE.BUY_COUPON_ACTION' | translate }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <h5 class="mb-1"
                *ngIf="shopCoupons.length > 0 || shop.cashback">{{ 'CASHBACK.DETAILS_PAGE.OTHER_OFFERS' | translate: {name: shop.name} }}</h5>
        </div>
    </ng-template>

    <div class="offers-wide">
        <div class="medical-cards">
            <div class="d-flex customOffers">
                <div class="card clickable" *ngFor="let coupon of shopCoupons" (click)="pickCoupon(coupon)">
                    <div class="card-header text-left">
                        <div class="card-title">
                            <span *ngIf="coupon.discountPercent === 0; else hasDiscountValue"
                                  class="display-4 brick-red darken-2">
                                {{ 'CASHBACK.DETAILS_PAGE.GENERAL_OFFER' | translate }}
                            </span>
                            <ng-template #hasDiscountValue>
                                <span class="display-3 brick-red darken-2">{{ coupon.discountPercent }}</span>&nbsp;<span
                                    class="display-5 brick-red darken-2 text-left" *ngIf="coupon.discountType === 'percent'">%</span>
                                <span
                                        class="display-5 brick-red darken-2 text-left" *ngIf="coupon.discountType === 'fixed'">RON</span>
                            </ng-template>
                        </div>
                        <hr/>
                    </div>
                    <div class="card-body mb-0 spaced-content">
                        <div>
                            <p>{{ coupon.title }}</p>
                            <p>{{ coupon.description }}</p>
                        </div>
                        <div>
                            <h6 class="card-subtitle small-text mt-1">{{ 'CASHBACK.DETAILS_PAGE.VALID_UNTIL' | translate: {'date': coupon.endDate} }}</h6>
                            <a class="card-link c-company bold"
                               (click)="pickCoupon(coupon)">{{ 'CASHBACK.DETAILS_PAGE.SELECT_COUPON_ACTION' | translate }}</a>
                        </div>
                    </div>
                </div>
                <div class="card clickable" *ngIf="shop.cashback" (click)="loadCashback(shop)">
                    <div class="card-header text-left">
                        <div class="card-title">
                            <span class="display-3 brick-red darken-2">{{ shop.cashback.cashbackValue.replace("până la", "").replace('%', '') }}</span>&nbsp;<span
                                class="display-5 brick-red darken-2 text-left">%</span>
                            <br />
                        </div>
                        <hr/>
                    </div>
                    <div class="card-body mb-0 spaced-content">
                        <div>
                            <p>Cashback</p>
                            <p *ngIf="shop.cashback.averagePayoutTerm">{{ 'CASHBACK.DETAILS_PAGE.AVERAGE_PAYOUT' | translate : {payout: shop.cashback.averagePayoutTerm} }}</p>
                            <p [innerHTML]="shop.cashback.cashbackConditions" style="max-height: 350px; overflow-y: auto"></p>
                        </div>
                        <div>
                            <a class="card-link c-company bold">
                                {{ 'CASHBACK.DETAILS_PAGE.SELECT_CASHBACK_ACTION' | translate }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
